import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/common/Navbar';

export default function OnboardingSuccess() {
  return (
    <>
      <header className="header-area">
        <Navbar />
      </header>
      <div
        style={{
          maxWidth: '600px',
          margin: '80px auto',
          textAlign: 'center',
          padding: '40px',
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{ fontSize: '60px', marginBottom: '16px' }}>✅</div>
        <h2 style={{ color: '#033132', marginBottom: '12px' }}>
          Thank you for your submission!
        </h2>
        <p style={{ color: '#555', fontSize: '16px', lineHeight: '1.6', marginBottom: '24px' }}>
          We have duly received the information for the purpose of preparing the necessary account
          opening, KYC, and agreement-related documentation. We shall provide the filled paperwork
          for your signature in the next few days.
        </p>
        <p style={{ color: '#555', fontSize: '15px', marginBottom: '32px' }}>
          Please check your email — we have sent you a copy of the Risk Profiling Report.
        </p>
        <Link
          to="/"
          style={{
            display: 'inline-block',
            background: '#033132',
            color: '#fff',
            padding: '12px 32px',
            borderRadius: '4px',
            textDecoration: 'none',
            fontSize: '15px',
          }}
        >
          Back to Home
        </Link>
      </div>
    </>
  );
}
